import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import VoterIdOutputComponent from '../output/VoterIdOutputComponent';

const VoterIdInputComponent = ({ serviceId, serviceDetails, leadId }) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        banner={{ icon: 'pi-id-card', title: 'Voter ID Verification', subtitle: 'Verify Voter ID details with the Election Commission' }}
        fields={[
            { name: 'card_number', label: 'Voter ID (EPIC)', icon: 'pi-id-card', placeholder: 'ABC1234567', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true },
            { name: 'mobile', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
            { name: 'pan', label: 'PAN (optional)', icon: 'pi-credit-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              required: false },
        ]}
        endpoint={{
            path: '/tartan/voter-id/verify',
            bodyMapper: (v, sid, lid) => ({
                card_number: v.card_number,
                mobile: v.mobile,
                ...(v.pan && { pan: v.pan }),
                application_id: 'test',
                api_provider_service_id: parseInt(sid, 10),
                ...(lid ? { lead_id: parseInt(lid, 10) } : {}),
            }),
        }}
        consentReportType="voter-id"
        submitLabel="Verify Voter ID"
        successSummary="Voter ID verified"
        errorSummary="Voter ID verification failed"
        confirmHeader="Confirm Voter ID verification"
        confirmAcceptLabel="Yes, verify"
        outputComponent={VoterIdOutputComponent}
    />
);

export default VoterIdInputComponent;
